import React from 'react';
import { InputFieldWrapper } from '@components-shared/forms/FieldLabel';
import cn from 'classnames';
import NumericInput from './NumericInput';

export interface IProps {
  name: string;
  title?: string;
  attributes?: { autoComplete?: string; disabled?: boolean };
  valid: boolean;
  validationMessage?: string;
  value: string;
  step?: number;
  allowNegativeValues?: boolean;
  precision?: number;
  hintMessage?: string;
  required?: boolean;
  className?: string;
  onChange: (name: string, value: string) => void;
  hideNumericArrows?: boolean;
  tooltip?: string;
  placeholders?: Record<string, string>;
}

const NumberInput: React.FC<IProps> = ({
  name,
  title,
  attributes,
  valid,
  validationMessage,
  tooltip,
  hideNumericArrows,
  value,
  step,
  allowNegativeValues,
  precision,
  hintMessage,
  required,
  className,
  onChange,
  placeholders,
}) => {
  const isDuplicateError = validationMessage === hintMessage;
  const hintMessageValue = isDuplicateError ? '' : hintMessage;

  return (
    <InputFieldWrapper
      title={title}
      name={name}
      className={className}
      tooltip={tooltip}
      required={required}
      valid={valid}
      validationMessage={validationMessage}
      placeholders={placeholders}
      hintMessage={hintMessageValue}>
      <NumericInput
        className={cn('form__input', { invalid: !valid })}
        name={name}
        step={step}
        allowNegativeValues={allowNegativeValues}
        disabled={attributes?.disabled}
        hideNumericArrows={hideNumericArrows}
        value={value}
        precision={precision}
        onChange={(value) => onChange(name, String(value))}
      />
    </InputFieldWrapper>
  );
};

export default NumberInput;
